<!-- https://www.freakyjolly.com/angular-image-uploader-with-cropper-and-preview-tutorial-with-example/ -->
<div>
  <div class="pb-2">
    <!--<p-fileUpload name="myfile[]" customUpload="true" (change)="fileChangeEvent($event)"></p-fileUpload>-->
    <input pInputText
           type="file"
           accept="image/*"
           (change)="fileChangeEvent($event)"
           [disabled]="uploading"/>
  </div>
</div>
@if (imageSelected) {
  <div class="p-fluid formgrid grid p-inputtext-sm">
    <div class="field col-12 md:col-6 text-center">
      <h3>{{'CROP_IMAGE' | translate}}</h3>
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="1"
        [resizeToWidth]="maxWidth"
        format="jpeg"
        [imageQuality]="80"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"/>
    </div>
    <div class="field col-6 text-center hidden md:inline">
      <h3>{{'PREVIEW' | translate}}</h3>
      <img [src]="croppedImage"/>
    </div>
  </div>

  @if (errorMsg) {
    <div  class="pt-2">
      <p-message severity="error" [text]="errorMsg"/>
    </div>
  }

  <h3>
    {{'GUIDELINES_FOR_UPLOADING_CONTENT' | translate}}
  </h3>
  <div [innerHTML]="'GUIDELINES_FOR_UPLOADING_CONTENT_HTML' | translate">
  </div>
  <div class="py-2 md:py-3">
    <app-checkbox [(value)]="policyAccepted" [label]="'ACCEPT_TERMS_AND_CONDITIONS' | translate"
                  classLabel="font-bold"/>
  </div>
  <div class="pt-2">
    <p-button [label]="'SAVE_IMAGE' | translate" (click)="saveImage()" [loading]="uploading"
              [disabled]="!policyAccepted"/>
  </div>
}
